import { UserFormState } from "~/types/data/User.types";

export const userFormStateInitState: UserFormState = {
  resolveFieldUsername: "",
  email: "",
  phoneNumber: "",
  preferredUsername: "",
  deactivated: false,
};
